import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ConstantsService {
  private readonly url = "/v1/constantes"
  private readonly _httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(private readonly httpClient: HttpClient) { }


  findConstants() : Observable<any>{
    const headers = this._httpHeaders;
    return this.httpClient.get<any>(this.url,{headers});
  }
}
